import { ISelectedOption } from '../@types/searchBox';

export const convertTaggedUsersInitialState = (tagged?: ISelectedOption[]) => {
  const taggedUsersInitialState: ISelectedOption[] =
    tagged && tagged.length > 0
      ? tagged.map((taggedUser: ISelectedOption) => {
          if (taggedUser.userFirstName) {
            return {
              id: taggedUser.id,
              text: `${taggedUser.userFirstName} ${taggedUser.userLastName}`,
            };
          }
          return taggedUser;
        })
      : [];

  return taggedUsersInitialState;
};
